<template>
  <header>
    <div class="mobile-header fixed-top" :class="getRespondClass">
      <div class="float-left v-center">
        <img id="header-logo" v-if="logo == 'MM-logo.png'" class="w-60 mt1" src="@/assets/MM-logo.png" alt="MentorMentee" @click="logoTapRedirect" style="width: 125px; height: 47px;">
        <img id="header-logo" v-else-if="logo != ''" class=" w-60 mt1" :src="apiUrl + '/web/site_logo/' + logo" alt="MentorMentee" @click="logoTapRedirect" style="width: auto;">
        <div class="tag_msg" v-if="logo != 'MM-logo.png'" style="">POWERED BY MENTOR MENTEE</div>

      </div>
      <div class="float-right">

        <div>
          <b-dropdown id="dropdown-1" :text="first_name" class="m-md-2">
            <div v-if="!this.$store.state.user_locations.isUserLinkedMultipleLocations">
              <b-dropdown-text><router-link :to="url"><span class="fa-icon-width">
                <img class="menu_icon" src="@/assets/manager/home_icon_dashboard_not_selected.png" />
              </span> Home</router-link></b-dropdown-text>
              <b-dropdown-text v-if="(isManager && !isEnterpriseAdmin) || ($store.state.switch_admin_username && !isEnterpriseAdmin)">
                <router-link to="/admin-console"><span class="fa-icon-width">
                  <img class="menu_icon" src="@/assets/manager/admin_console_not_selected.png" />
                </span> Admin</router-link>
              </b-dropdown-text>
              <b-dropdown-text ><router-link to="/myprofile"><span class="fa-icon-width">
                <img class="menu_icon" src="@/assets/manager/my_profile_menu_icon_not_selected.png" />                
              </span> My Profile</router-link></b-dropdown-text>
              
             
              <b-dropdown-text v-if="(isManager && !isEnterpriseAdmin) || ($store.state.switch_admin_username && !isEnterpriseAdmin) || isMentor || isMentee | isApprentice">
              <router-link to="/my-badges"><span class="fa-icon-width">
                <img class="menu_icon" src="@/assets/manager/my_badges_menu_icon_not_selected.png" />                
              </span> My Badges</router-link>
              </b-dropdown-text>
              
            
              <b-dropdown-text><router-link to="/logout"><span class="fa-icon-width">
                <img class="menu_icon" src="@/assets/manager/sign_out_menu_icon.png" />
              </span> Sign Out</router-link></b-dropdown-text>
              <b-dropdown-text v-if="$store.state.switch_admin_username">
                <div class="switch_user">
                  <span @click="switchUserLogout()"><a class="cursor-pointer"><span class="fa-icon-width"><i class="fa fa-power-off" aria-hidden="true"></i></span> Logout as Admin</a></span>
                </div>
              </b-dropdown-text>
            </div>
            <div v-if="this.$store.state.user_locations.isUserLinkedMultipleLocations">
              <b-dropdown-text><router-link :to="url"><span class="fa-icon-width"><i class="fa fa-tachometer" aria-hidden="true"></i></span> Dashboard</router-link></b-dropdown-text>
               <b-dropdown-text v-if="isManager || $store.state.switch_admin_username">
                <router-link to="/admin-console"><span class="fa-icon-width"><i class="fa fa-users" aria-hidden="true"></i></span> Admin</router-link>
              </b-dropdown-text>
              <b-dropdown-text v-if="!isEnterpriseAdmin"><router-link to="/myprofile"><span class="fa-icon-width"><i class="fa fa-user" aria-hidden="true"></i></span> My Profile</router-link></b-dropdown-text>
              <b-dropdown-text v-if="isEnterpriseAdmin"><router-link to="/enterprise-admin/myprofile"><span class="fa-icon-width"><i class="fa fa-user" aria-hidden="true"></i></span> My Profile</router-link></b-dropdown-text>
              <b-dropdown-text v-if="isMentor">
                <router-link to="/my-tasklists"><span class="fa-icon-width"><i class="fa fa-tasks" aria-hidden="true"></i></span> Task Lists</router-link>
              </b-dropdown-text>
              <b-dropdown-text v-if="isMentee || isApprentice">
                <router-link to="/mentee-my-tasklists"><span class="fa-icon-width"><i class="fa fa-tasks" aria-hidden="true"></i></span> Task Lists</router-link>
              </b-dropdown-text>
           
              <b-dropdown-text><router-link to="/logout"><span class="fa-icon-width"><i class="fa fa-arrow-circle-left" aria-hidden="true"></i></span> Sign Out</router-link></b-dropdown-text>
              <b-dropdown-text v-if="$store.state.switch_admin_username">
                <div class="switch_user">
                  <span @click="switchUserLogout()"><a class="cursor-pointer"><span class="fa-icon-width"><i class="fa fa-power-off" aria-hidden="true"></i></span> Logout as Admin</a></span>
                </div>
              </b-dropdown-text>
            </div>
            <b-dropdown-text v-if="this.$store.state.user_locations.isUserLinkedMultipleLocations">
              <div class="switch_user" v-show="switchToMentor">
                <span @click="switchUser('Manager')" v-show="managerFlag"><a class="cursor-pointer"><span class="fa-icon-width"><i class="fa fa-exchange" aria-hidden="true"></i></span> Switch to Admin</a></span>
                <span @click="switchUser('Mentor')" v-show="mentorFlag"><a class="cursor-pointer"><span class="fa-icon-width"><i class="fa fa-exchange" aria-hidden="true"></i></span> Switch to Mentor</a></span>
              </div>
              <div class="switch_user" v-show="switchToInstructor">
                <span @click="switchUser('Primary Admin')" v-show="primaryadminFlag"><a class="cursor-pointer"><span class="fa-icon-width"><i class="fa fa-exchange" aria-hidden="true"></i></span> Switch to Admin</a></span>
                <span @click="switchUser('Instructor')" v-show="instructorFlag"><a class="cursor-pointer"><span class="fa-icon-width"><i class="fa fa-exchange" aria-hidden="true"></i></span> Switch to Instructor</a></span>
              </div>
            </b-dropdown-text>
            <b-dropdown-text v-if="this.$store.state.user_locations.isUserLinkedMultipleLocations">
              <b-dropdown-divider></b-dropdown-divider>
              <a class="cursor-pointer location-dd" v-b-toggle="'collapse-buildable-submenu'" @click="showLocations">
                <span class="fa-icon-width">
                  <i class="fa fa-map-marker"></i>
                </span>Locations
                <i v-if="!isLocationListDisplay" class="fa fa-angle-down location_down_arrow"></i>
                <i v-if="isLocationListDisplay" class="fa fa-angle-up location_down_arrow"></i>
              </a>
            </b-dropdown-text>
            <b-collapse v-if="this.$store.state.user_locations.isUserLinkedMultipleLocations" v-bind:id="'collapse-buildable-submenu'">
                <b-dropdown-text>
                  <a class="cursor-pointer">
                    <div class="float-left trim-text">
                      <span class="font-weight-bold">{{ currentLocation.accountName }}</span><br/>
                      {{ formatAddress(currentLocation.city, currentLocation.stateName) }}
                    </div>
                    <button 
                      class="btn btn-sm currentBtn">
                      Current
                    </button>
                  </a>
                </b-dropdown-text>
                <b-dropdown-text>
                  <a class="cursor-pointer">
                    <div class="float-left trim-text">
                      <span class="font-weight-bold">{{ selectLocation.accountName }}</span><br/>
                      {{ formatAddress(selectLocation.city, selectLocation.stateName) }}
                    </div>
                    <button 
                      class="btn btn-sm selectBtn" 
                      @click="setCurrentLocation(selectLocation)">
                      Select
                    </button>
                  </a>
                </b-dropdown-text>
            </b-collapse>

          </b-dropdown>
        </div>

        <LocationSwitchNotificationModal
          :isLocationSwitchNotificationModalVisible="isLocationSwitchNotificationModalVisible"
          :userFullName="userFullName"
          :notifyMessage="notifyMessage"
          @close="closeLocationSwitchNotificationModal"
        />

      </div>
    </div>
 </header>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import store from '../../store/store.js';
import router from '../../router/index.js';
import axios from 'axios';
import LocationSwitchNotificationModal from './location_switch_notification_modal.vue';

export default {
  data: function () {
    return {
      first_name: this.$store.state.first_name,
      email: this.$store.state.email,
      url: '',
      switchToMentor: false,
      switchToInstructor: false,
      managerFlag: false,
      mentorFlag: false,
      primaryadminFlag: false,
      instructorFlag: false,
      sidebar: false,
      isShowMentor: false,
      isMentee: false,
      isApprentice: false,
      isMentor: false,
      isEnterpriseAdmin: false,
      currentLocation: {},
      selectLocation: {},
      userAccounts: {
        isUserLinkedMultipleLocations: false,
        locations: [],
      },
      isLocationListDisplay: false,
      isLocationSwitchNotificationModalVisible: false,
      userFullName: '',
      notifyMessage: '',
      isManager: false,
      apiUrl: '',
      logo: '',
      height: '',
    }
  },
  computed: {
    getRespondClass() {
      if(this.height > 65) {
        return 'mobile-header-1';
      }
      else {
        return '';
      }
    },
  },
  components: {
    LocationSwitchNotificationModal
  },
  methods: {
    switchUser: function(role) {
      if (this.$store.state.user_accountid) {
        this.$store.dispatch('switch_user', role);
        var url = this.userRedirect(role);
        if(url != '') {
          this.navigate(url);
        }
      } else {
        return true;
      }
    },
    toggleToIcons() {
      if(this.sidebar == true) {
        this.sidebar = false;
      }
      else {
        this.sidebar = true;
      }
    },
    toggleToIconsDisplay() {
      var roles = this.$store.state.roles;
      if(
        ((roles.indexOf('ROLE_ADMIN') > -1) && ((this.$store.state.switch_flag != 'Instructor') && (this.$store.state.switch_flag != 'Mentor')))
        ||
        ((this.$store.state.switch_admin_username) && (this.$store.state.switch_admin_roles.indexOf('ROLE_ADMIN') > -1) && ((this.$store.state.switch_flag != 'Instructor') && (this.$store.state.switch_flag != 'Mentor')))
        )
      {
        return true;
      }
      else {
        return false;
      }
    },
    switchUserLogout: function() {
      document.documentElement.style.setProperty('--main-bg-color', '#00ACEE');
      this.$logoName = 'MM-logo.png';
      this.$store.dispatch('switch_user', '');
      this.$store.dispatch('switch_admin_user', '');
      this.$store.dispatch('active_tab', '');
      var userLocationObj = {
          isUserLinkedMultipleLocations: false,
          locations: [],
          current: {},
      };
      this.$store.dispatch('set_user_accountid', '');
      this.$store.dispatch('set_user_locations', userLocationObj);
      this.$store.dispatch('set_multi_user_logged_time', '');

      router.push('/admin-dashboard');
    },
    goBack() {
      var current_url = window.location.pathname;
      if(current_url.indexOf('create-headings-tasks') > -1) {
        var url_array = current_url.split('/');
        router.push('/create-sub-tasklists/' + url_array[3]);
      }
      else if(current_url.indexOf('create-sub-tasklists') > -1) {
        router.push('/view-tasklist');
      }
      else {
        router.go(-1)
      }
    },
    userRedirect: function(role) {
      var url = '';
      if(role == 'Manager') {
        url = "/company-admin-dashboard";
      }
      else if(role == 'Mentor') {
        url = "/mentor-dashboard";
      }
      else if(role == 'Primary Admin') {
        url = "/school-admin-dashboard";
      }
      else if(role == 'Instructor') {
        url = "/students-tasks-list";
      }
      else if(role == 'Researcher') {
        url = "/researcher-dashboard";
      }
      else if(role == 'CSR') {
        url = "/csr-dashboard";
      }
      return url;
    },
    openNav() {
      document.getElementById("userSidenav").style.width = "250px";
    },
    closeNav() {
      document.getElementById("userSidenav").style.width = "0";
    },
    IsUserManagerMentor() {
      var roles = this.$store.state.roles;
      if(
        (roles.indexOf('ROLE_ADMIN') > -1 && roles.indexOf('ROLE_MENTOR') > -1)
        ||
        ((this.$store.state.switch_admin_username) && (this.$store.state.switch_admin_roles.indexOf('ROLE_ADMIN') > -1 && this.$store.state.switch_admin_roles.indexOf('ROLE_MENTOR') > -1))
        )
      {
        return true;
      }
      else {
        return false;
      }
    },
    IsUserPrimaryAdminInstructor() {
      var roles = this.$store.state.roles;
      if(
        (roles.indexOf('ROLE_ADMIN') > -1 && roles.indexOf('ROLE_INSTRUCTOR') > -1)
        ||
        ((this.$store.state.switch_admin_username) && (this.$store.state.switch_admin_roles.indexOf('ROLE_ADMIN') > -1 && this.$store.state.switch_admin_roles.indexOf('ROLE_INSTRUCTOR') > -1))
        )
      {
        return true;
      }
      else {
        return false;
      }
    },
    checkIsMentee() {
       var roles = this.$store.state.roles;
      if(roles.indexOf('ROLE_MENTEE') > -1)
      {
        return true;
      }
      else  {
        return false;
      }
    },
    checkIsApprentice() {
       var roles = this.$store.state.roles;
      if(roles.indexOf('ROLE_APPRENTICE') > -1)
      {
        return true;
      }
      else  {
        return false;
      }
    },
    checkIsMentor() {
       var roles = this.$store.state.roles;
      if(roles.indexOf('ROLE_MENTOR') > -1)
      {
        return true;
      }
      else  {
        return false;
      }
    },
    checkIsManager() {
       var roles = this.$store.state.roles;
      if(roles.indexOf('ROLE_ADMIN') > -1)
      {
        return true;
      }
      else  {
        return false;
      }
    },
    navigate(path) {
  	  if (this.$store.state.user_accountid) {
        router.push(path);
      } else {
        return true;
      }
  	},
    logoTapRedirect: function() {
      var roles = this.$store.state.roles;
      if (this.$store.state.user_accountid) {
        var url = '';
        if(roles.indexOf('ROLE_ADMIN') > -1 && (this.$store.state.switch_flag && this.$store.state.switch_flag.toLowerCase() == 'manager')) {
          url = "/company-admin-dashboard";
        }
        else if(roles.indexOf('ROLE_MENTOR') > -1 || (this.$store.state.switch_flag && this.$store.state.switch_flag.toLowerCase() == 'mentor')) {
          url = "/mentor-dashboard";
        }
        else if((roles.indexOf('ROLE_ENTERPRISE_ADMIN') > -1) || (this.$store.state.switch_admin_enterprise_flag == 1)) {
          url = "/enterprise-admin-dashboard";
        }
        else if(roles.indexOf('ROLE_PRIMARY_ADMIN') > -1) {
          url = "/school-admin-dashboard";
        }
        else if(roles.indexOf('ROLE_INSTRUCTOR') > -1) {
          url = "/students-tasks-list";
        }
        else if(roles.indexOf('ROLE_MENTEE') > -1) {
          url = "/mentee-dashboard";
        }
        else if(roles.indexOf('ROLE_APPRENTICE') > -1) {
          url = "/apprentice-dashboard";
        }
        else if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
          url = "/admin-dashboard";
        }
        else if(roles.indexOf('ROLE_RESEARCHER') > -1) {
          url = "/researcher-dashboard";
        }
        else if(roles.indexOf('ROLE_CSR') > -1) {
          url = "/csr-dashboard";
        }
        router.push(url);
      } else {
        if (this.isEnterpriseAdmin) {
          router.push("/enterprise-admin-dashboard");
        } else if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
          router.push("/admin-dashboard");
        } else if(roles.indexOf('ROLE_RESEARCHER') > -1) {
          router.push("/researcher-dashboard");
        } else if(roles.indexOf('ROLE_CSR') > -1) {
          router.push("/csr-dashboard");
        } else {
          return true;
        }
      }
      
    },
    checkIsEnterpriseAdmin() {
       var roles = this.$store.state.roles;
      if(roles.indexOf('ROLE_ENTERPRISE_ADMIN') > -1)
      {
        return true;
      }
      else  {
        if (this.$store.state.switch_admin_roles && this.$store.state.switch_admin_roles.indexOf('ROLE_ENTERPRISE_ADMIN') > -1) {
          return true;
        } else {
          return false;
        }
      }
    },
    formatAddress(city, state) {
      var address = '';
      if (city) {
          address += city + ", ";
      }
      if (state) {
          address += state + ", ";
      }
      return address.slice(0, -2);
    },
    formatGroupTitle(groups) {
      return (groups.length > 1) ? "Mentors: ": "Mentor: ";
    },
    showLocations() {
      if (!this.isLocationListDisplay) {
        this.isLocationListDisplay = true;
        this.loadUserMultipleLocations();
      } else {
        this.isLocationListDisplay = false;
      }
    },
    setCurrentLocation(item) {
      this.$store.dispatch('set_user_accountid', item.accId);
      this.$store.dispatch('set_user_locations', this.userAccounts);
      this.saveUserLoggedTime();
      router.push(this.url);
      location.reload();
    },
    getCurrentLocation(accId) {
      return (accId == this.$store.state.user_accountid) ? true : false;
    },
    loadUserMultipleLocations() {
      if (this.$store.state.user_locations.isUserLinkedMultipleLocations) {
        this.userAccounts.isUserLinkedMultipleLocations = this.$store.state.user_locations.isUserLinkedMultipleLocations;
        this.userAccounts.locations = this.$store.state.user_locations.locations;
        if (this.$store.state.user_accountid) {
          this.currentLocation = this.$store.state.user_locations.locations.find(loc => loc.accId === this.$store.state.user_accountid);
          this.selectLocation = this.$store.state.user_locations.locations.find(loc => loc.accId != this.$store.state.user_accountid);
        } else {
          this.currentLocation = this.$store.state.user_locations.locations[0];
          this.selectLocation = this.$store.state.user_locations.locations[1];
        }
      }
    },
    checkUserLoggedInterval() {
      if (this.$store.state.user_locations.isUserLinkedMultipleLocations
       && this.$store.state.user_accountid) {

        var userLoggedInTime = this.$store.state.multi_user_logged_in_time;
        
        //event call on every a minute
        setInterval(() => {
          var currentdate = new Date(); 
          var currentDateTime = currentdate.getFullYear() + "-"
                                  + (currentdate.getMonth()+1)  + "-" 
                                  +  currentdate.getDate() + " "  
                                  + currentdate.getHours() + ":"  
                                  + currentdate.getMinutes() + ":" 
                                  + currentdate.getSeconds();
          var current_time = currentDateTime;
          axios('/check-multi-account-user-notification', {
            method: 'POST',
            data: {
              logged_time: userLoggedInTime,
              current_time: current_time,
              account_id: this.$store.state.user_accountid,
            }
          })
          .then(response =>  {
            if (response.data.enable_notifcation) {
              this.isLocationSwitchNotificationModalVisible = true;
              this.userFullName = response.data.user_fullname;
              this.notifyMessage = response.data.notify_message;
            } else {
              this.isLocationSwitchNotificationModalVisible = false;
            }
          })
          .catch((error) => {
              console.log(error);
          });
        }, 60000);
      }
    },
    closeLocationSwitchNotificationModal() {
      this.saveUserLoggedTime();
      this.isLocationSwitchNotificationModalVisible = false;
    },
    saveUserLoggedTime() {
      var currentdate = new Date(); 
      var currentDateTime = currentdate.getFullYear() + "-"
                              + (currentdate.getMonth()+1)  + "-" 
                              +  currentdate.getDate() + " "  
                              + currentdate.getHours() + ":"  
                              + currentdate.getMinutes() + ":" 
                              + currentdate.getSeconds();
      this.$store.dispatch('set_multi_user_logged_time', currentDateTime);
    }
  },
  created() {
    this.apiUrl = process.env.API_ENDPOINT;
    if(this.$logoName == '') {
      if(this.$store.state.user_accountid) {
      axios('/desktop/get-account-color-code-logo/' + this.$store.state.user_accountid,
      {
        method: 'GET',
      })
      .then(resp => {
        this.height = resp.data.height;
        if(resp.data.logoName) {
            this.$logoName = resp.data.logoName;
            Vue.prototype.$isBranding = 1;
        }
        else {
            this.$logoName = 'MM-logo.png';
            Vue.prototype.$isBranding = '';
        }
        this.logo = this.$logoName;
        if(resp.data.buttonColorCode) {
          document.documentElement.style.setProperty('--main-bg-color', resp.data.buttonColorCode);
        }
        else {
          document.documentElement.style.setProperty('--main-bg-color', '#00ACEE');
        }
      })
      .catch(() => {
      });
      }
      else {
        this.$logoName = 'MM-logo.png';
        this.logo = this.$logoName;
      }
    }
    else {
      this.logo = this.$logoName;
    }
    if(this.$store.getters.isLoggedIn) {
      var roles = this.$store.state.roles;
      if(this.$store.state.switch_flag) {
        this.url = this.userRedirect(this.$store.state.switch_flag);
        if((this.$store.state.switch_admin_username)) {
          this.first_name = this.$store.state.switch_admin_firstname;
        }
      }
      else if((roles.indexOf('ROLE_MASTER_ADMIN') > -1) && ((!this.$store.state.switch_admin_username) || (this.$store.state.switch_admin_username == ''))) {
        this.url = '/admin-dashboard';
      }
      else if((roles.indexOf('ROLE_RESEARCHER') > -1)) {
        this.url = '/researcher-dashboard';
      }
      else if((roles.indexOf('ROLE_CSR') > -1)) {
        this.url = '/csr-dashboard';
      }
      else if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
        if((this.$store.state.switch_admin_username)) {
          this.first_name = this.$store.state.switch_admin_firstname;
        }
        if((this.$store.state.school_flag == 1) || (this.$store.state.switch_admin_account_flag == 1)) {
          this.url = '/school-admin-dashboard';
        }
        else {
          if (this.$store.state.switch_admin_enterprise_flag) {
            this.url = '/enterprise-admin-dashboard';
          } else {
            this.url = '/company-admin-dashboard';
          }
        }
      }
      else if(roles.indexOf('ROLE_MENTOR') > -1) {
        this.url = '/mentor-dashboard';
      }
      else if(roles.indexOf('ROLE_MENTEE') > -1) {
        this.url = '/mentee-dashboard';
      }
      else if(roles.indexOf('ROLE_INSTRUCTOR') > -1) {
        this.url = '/students-tasks-list';
      }
      else if(roles.indexOf('ROLE_STUDENT') > -1) {
        this.url = '/student-dashboard';
      }
      else if(roles.indexOf('ROLE_APPRENTICE') > -1) {
        this.url = '/apprentice-dashboard';
      }
      else if(roles.indexOf('ROLE_ENTERPRISE_ADMIN') > -1) {
        this.url = '/enterprise-admin-dashboard';
      }
    }
    this.switchToMentor = this.IsUserManagerMentor();
    if(this.switchToMentor == true) {
      if(!this.$store.state.switch_flag) {
        this.$store.dispatch('switch_user', 'Manager');
      }
      if((this.$store.state.switch_flag == 'Mentor')) {
        this.managerFlag = true;
      }
      if((this.$store.state.switch_flag == 'Manager')) {
        this.mentorFlag = true;
      }
    }
    this.switchToInstructor = this.IsUserPrimaryAdminInstructor();
    if(this.switchToInstructor == true) {
      if(!this.$store.state.switch_flag) {
        this.$store.dispatch('switch_user', 'Primary Admin');
      }
      if((this.$store.state.switch_flag == 'Instructor')) {
        this.primaryadminFlag = true;
      }
      if((this.$store.state.switch_flag == 'Primary Admin')) {
        this.instructorFlag = true;
      }
    }
    document.body.className = 'ma-body-bgcolor';
    if (roles.indexOf('ROLE_ADMIN') == 0) {
      this.isShowMentor = true;
    } else {
      this.isShowMentor = false;
    }
    this.isMentee = this.checkIsMentee();
    this.isMentor = this.checkIsMentor();
    this.isApprentice = this.checkIsApprentice();
    this.isEnterpriseAdmin = this.checkIsEnterpriseAdmin();
    this.isManager = this.checkIsManager();
   
    this.checkUserLoggedInterval();
  }
}
</script>

<style scoped>
.text-left {
  color: #FFF;
}
.user-detail {
  padding: 8px 8px 8px 32px;
}
.user-icon-wrapper {
  margin:10px 10px 0px 0px;
  cursor: pointer;
}
.back-btn-icon {
  font-size: 50px;
  font-weight: bold;
}
.fa-icon-width {
  width: 25px;
  display: inline-block;
}
#sidebar {
    min-width: 200px;
    max-width: 250px;
    background-color: #D4D4D4;
    transition: all 0.3s;
    min-height: 100vh;
    margin-top: 0px;
    position: fixed;
    opacity: 1;
    z-index: 1;
}
#sidebar.active {
    min-width: 60px;
    max-width: 60px;
    text-align: center;
}
#sidebar.active .menu-item-name {
   display: none;
}
#sidebar.active .sidebar-header h3 {
    display: none;
}

#sidebar.active .sidebar-header strong {
    display: block;
}

#sidebar ul li a {
    text-align: left;
    text-decoration: none;
}

#sidebar.active ul li a {
    padding: 0px 10px;
    text-align: center;
    font-size: 0.85em;
    text-decoration: none;
}

#sidebar.active ul li a i {
    margin-right: 0;
    display: block;
    font-size: 16px;
}

#sidebar.active ul ul a {
    padding: 10px !important;
}

#sidebar.active .dropdown-toggle::after {
    top: auto;
    bottom: 10px;
    right: 50%;
    -webkit-transform: translateX(50%);
    -ms-transform: translateX(50%);
    transform: translateX(50%);
}

#sidebar .sidebar-header {
    padding: 0px 10px 10px 10px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
}

#sidebar ul.components {
    padding: 5px 0;
    border-bottom: 1px solid #47748b;
}
#sidebar ul li a {
    padding: 0px 10px 0px 10px;
    display: block;
    color: #212529;
    margin-left: 5px;
}
#sidebar ul ul li a {
    padding: 2px;
}
#sidebar ul li a i {
    margin-right: 10px;
}
#sidebar ul li.active>a,
#sidebar a[aria-expanded="true"] {
    color: #212529;
}
a[data-toggle="collapse"] {
    position: relative;
}
.dropdown-toggle::after {
    display: block;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
}
.app-heading {
 margin-left: 10px;
}
.report-dropdown {
  float: right;
  font-size: 20px;
}
#sidebar.active ul ul {
  display: none;
}
#sidebar ul li {
  padding-top: 10px;
  padding-bottom: 10px;
}
#sidebar ul li a.nav-active, #sidebar ul li a.router-link-exact-active {
  border-left: 3px solid #00ACEE;
  margin-left: 2px;
}
#sidebar ul li a i {
  width: 15px;
}
#sidebar.active ul li a i {
  width: 35px;
}
#collapse-report-submenu ul li {
  padding-top: 0px;
  padding-bottom: 3px;
}
.mobile-header img {
  margin: 1px 10px;
  //width: 100px !important;
  cursor: pointer;
}
.location-dd { background: none; }
.currentBtn, .currentBtn:focus, .currentBtn:hover{
  color: #FFF !important;
  background-color: #8b8b8b !important;
  border: 1px solid #FFF !important;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 900;
  padding: 5px;
  width: 30%;
  float: right;
  cursor: none;
}
.selectBtn, .selectBtn:focus, .selectBtn:hover{
  color: #FFF !important;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 900;
  padding: 5px;
  width: 30%;
  float: right;
}
.trim-text {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 130px;
  white-space: nowrap;
}
.location_down_arrow { font-size: 26px; float: right; }
.mobile-header img.menu_icon {
  width: 15px !important;
  margin: 0 !important;
}
.v-center {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  margin: 0 auto;
  margin-top: 0px;
}
.tag_msg {
  font-family: "proxima-nova",sans-serif;
  font-size: 10px; 
  color: #979394; 
  padding-top: 1px; 
  padding-left: 5px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/user_menu.vue